// @ts-strict-ignore
import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import {
    Slide,
    Dialog,
    DialogTitle,
    DialogContent,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import type { SlideProps } from '@mui/material';

// See here: https://github.com/mui-org/material-ui/issues/17542
const Transition = forwardRef<unknown, SlideProps>(
    function Transition(props, ref) {
        return <Slide direction="down" ref={ref} {...props} />;
    },
);

export type AlertDialogProps = {
    setOpen(boolean): void;
    children: ReactNode;
    title: ReactNode;
    open: boolean;
    className?: string;
};
export default function AlertDialog(props: AlertDialogProps) {
    const { setOpen, children, title, open, className } = props;

    function handleClose() {
        setOpen(false);
    }

    const muiTheme = useTheme();
    const fullScreen = useMediaQuery(muiTheme.breakpoints.down('md'), {
        // https://github.com/mui-org/material-ui/issues/21048
        noSsr: true,
    });

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            classes={{
                paper: className,
            }}
        >
            <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
            <DialogContent>
                <div style={{ padding: 5 }}>{children}</div>
            </DialogContent>
            {/*<DialogActions>
             <Button onClick={handleClose} color="primary">
                 Disagree
             </Button>
             <Button onClick={handleClose} color="primary">
                 Agree
             </Button>
         </DialogActions>*/}
        </Dialog>
    );
}
